import {AvatarPlaceholderColorClass} from '@Components/avatar-placeholder-icon/avatar-placeholder-icon.types';

export const getThumbnailColorClass = (name?: string | null): AvatarPlaceholderColorClass => {
  const colourValues = Object.values(AvatarPlaceholderColorClass);
  if (!name) return colourValues[0];

  const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return colourValues[hash % colourValues.length];
};

export const getThumbnailIconProps = (name?: string | null) => {
  const letter = name && name.length > 0 ? name[0].toUpperCase() : '';
  const colorClass = getThumbnailColorClass(name);
  
  return {
    placeholderLetter: letter,
    colorClass
  };
};
